var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0H24V24H0z","transform":"translate(-3 -3)","key":0}),React.createElement("g",{"stroke":"#000","strokeLinecap":"square","strokeWidth":"2","key":1},React.createElement("path",{"d":"M14 0L0 14M14 14L0 0","transform":"translate(-3 -3) translate(5 5)"}))]));
}

Close.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = Close;

Close.default = Close;
